import { render, staticRenderFns } from "./VlastLogo.vue?vue&type=template&id=98ab9aac"
import script from "./VlastLogo.vue?vue&type=script&lang=js"
export * from "./VlastLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports